import { useMemo, useState } from "react";
import {
  Activity, BookOpen, Brush, Home, Music, Waves, Users, Trophy, Target, HeartHandshake, Sparkles,
  GraduationCap, Briefcase, ClipboardCheck, Palette, Puzzle, Bus, MessageCircle, Award, Search, Check
} from "lucide-react";

export const ICON_LIBRARY = [
  { name: "Activity", Icon: Activity, keywords: "sport رياضة نشاط حركة" },
  { name: "BookOpen", Icon: BookOpen, keywords: "book read قراءة كتاب تعليم" },
  { name: "Brush", Icon: Brush, keywords: "art paint فن رسم إبداع" },
  { name: "Home", Icon: Home, keywords: "home life daily منزل بيت حياة" },
  { name: "Music", Icon: Music, keywords: "music song موسيقى غناء" },
  { name: "Waves", Icon: Waves, keywords: "swim water سباحة ماء مائي" },
  { name: "Users", Icon: Users, keywords: "team group فريق مجموعة" },
  { name: "Trophy", Icon: Trophy, keywords: "trophy award جائزة إنجاز" },
  { name: "Target", Icon: Target, keywords: "goal target هدف" },
  { name: "HeartHandshake", Icon: HeartHandshake, keywords: "care مساعدة رعاية" },
  { name: "Sparkles", Icon: Sparkles, keywords: "sparkle magic إبداع" },
  { name: "GraduationCap", Icon: GraduationCap, keywords: "grad school تخرج مدرسة" },
  { name: "Briefcase", Icon: Briefcase, keywords: "work career عمل مهني" },
  { name: "ClipboardCheck", Icon: ClipboardCheck, keywords: "check task تقييم مهمة" },
  { name: "Palette", Icon: Palette, keywords: "art color لون فن" },
  { name: "Puzzle", Icon: Puzzle, keywords: "puzzle autism توحد أحجية" },
  { name: "Bus", Icon: Bus, keywords: "trip travel رحلة" },
  { name: "MessageCircle", Icon: MessageCircle, keywords: "chat speech تواصل تخاطب" },
  { name: "Award", Icon: Award, keywords: "cert وسام شهادة" },
];

export default function IconPicker({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  const current = ICON_LIBRARY.find((it) => it.name === value) || ICON_LIBRARY[0];
  const CurrentIcon = current.Icon;

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return ICON_LIBRARY;
    return ICON_LIBRARY.filter((it) => it.name.toLowerCase().includes(s) || it.keywords.includes(s));
  }, [q]);

  return (
    <div className="relative" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full h-8 flex items-center gap-2 rounded-md border border-slate-200 bg-white px-2 text-xs font-bold text-slate-700 hover:border-slate-300"
        data-testid={`${testid}-button`}
      >
        <CurrentIcon className="w-4 h-4 text-indigo-600" />
        <span className="flex-1 text-right">{current.name}</span>
        <Search className="w-3 h-3 text-slate-400" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-1 w-72 max-w-[85vw] rounded-xl border-2 border-slate-200 bg-white shadow-2xl p-2 right-0" data-testid={`${testid}-popover`}>
            <div className="relative mb-2">
              <Search className="absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400" />
              <input
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="ابحث بالاسم أو الوصف..."
                className="w-full h-8 pr-7 pl-2 rounded-md border border-slate-200 text-xs"
                data-testid={`${testid}-search`}
              />
            </div>
            <div className="grid grid-cols-4 gap-1 max-h-56 overflow-y-auto">
              {filtered.map((it) => {
                const I = it.Icon;
                const selected = it.name === value;
                return (
                  <button
                    key={it.name}
                    type="button"
                    onClick={() => { onChange(it.name); setOpen(false); setQ(""); }}
                    className={`relative flex flex-col items-center gap-0.5 p-2 rounded-lg border-2 transition-all ${selected ? "bg-indigo-50 border-indigo-400 text-indigo-700" : "border-transparent hover:bg-slate-50"}`}
                    title={it.name}
                    data-testid={`${testid}-opt-${it.name}`}
                  >
                    <I className="w-5 h-5" />
                    <span className="text-[9px] font-bold truncate w-full text-center">{it.name}</span>
                    {selected && <Check className="absolute top-0.5 right-0.5 w-3 h-3 text-indigo-600" />}
                  </button>
                );
              })}
              {filtered.length === 0 && (
                <div className="col-span-4 py-6 text-center text-xs text-slate-400">لا نتائج</div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
